import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/tutorial-menu.svg'


const _hoisted_1 = { class: "tutorial__item" }
const _hoisted_2 = { class: "tutorial__text-box" }
const _hoisted_3 = { class: "tutorial__btn-box" }

import { computed } from 'vue'
import { BookTutorial, BookTutorialStep } from '@/models/doc.tutorial'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarTutorialStepTOC',
  props: {
    bookTutorial: {}
  },
  setup(__props: any) {

const props = __props

const isActive = computed(() => {
  return props.bookTutorial.step === BookTutorialStep.toc
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "tutorial__image-box" }, [
          _createElementVNode("img", {
            class: "tutorial__image",
            src: _imports_0,
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "tutorial__title" }, "Table of contents", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "tutorial__text" }, " Here you’ll find everything else, including the full chapter-by-chapter guide, your highlights, PDF downloads, and book discussions. ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              class: "tutorial__btn btns",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.bookTutorial.incrementStep()))
            }, [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Next", -1),
              _createElementVNode("span", { class: "tutorial__btn-arr iconfont inext" }, null, -1)
            ]))])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("ul", { class: "tutorial__dots" }, [
            _createElementVNode("li", { class: "tutorial__dot" }),
            _createElementVNode("li", { class: "tutorial__dot" }),
            _createElementVNode("li", { class: "tutorial__dot" }),
            _createElementVNode("li", { class: "tutorial__dot" }),
            _createElementVNode("li", { class: "tutorial__dot" })
          ], -1))
        ])
      ], 512), [
        [_vShow, isActive.value]
      ])
    ]),
    _: 1
  }))
}
}

})